import React, { useState } from 'react';

const links = [
    <a
        href="https://www.accordmortgages.com/existing-customers/privacy/index.html"
        target="_blank"
        className="underline"
        key="accord"
    >
        Accord Mortgages
    </a>,
    <a
        href="https://www.aegon.co.uk/support/faq/privacy.html"
        target="_blank"
        className="underline"
        key="aegon"
    >
        Aegon
    </a>,
    <a
        href="https://www.aiglife.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="aig"
    >
        AIG
    </a>,
    <a
        href="https://www.aldermore.co.uk/legal/privacy-policy/"
        target="_blank"
        className="underline"
        key="aldermore"
    >
        Aldermore Bank Plc
    </a>,
    <a
        href="https://alternativebridging.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="alternative-bridging"
    >
        Alternative Bridging Corporation Ltd
    </a>,
    <a
        href="https://apexbridging.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="apex-bridging"
    >
        HBB Bridging Ltd T/A Apex Bridging
    </a>,
    <a
        href="https://www.aspenbridging.co.uk/aspen/assets/Aspen%20Bridging%20Privacy%20Policy.pdf"
        target="_blank"
        className="underline"
        key="aspen-bridging"
    >
        Aspen Bridging
    </a>,
    <a
        href="https://www.atombank.co.uk/policies/privacy-and-data/"
        target="_blank"
        className="underline"
        key="atombank"
    >
        Atom Bank
    </a>,
    <a
        href="https://www.bambooloans.com/s/how-we-use-your-information/"
        target="_blank"
        className="underline"
        key="bamboo"
    >
        Bamboo Ltd T/A Bamboo Loans
    </a>,
    <a
        href="https://www.bathbuildingsociety.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="bath"
    >
        Bath Building Society
    </a>,
    <a
        href="https://www.bankofireland.com/privacy/data-protection-notice/"
        target="_blank"
        className="underline"
        key="bank-of-ireland"
    >
        Bank of Ireland
    </a>,
    <a
        href="https://www.barclays.co.uk/important-information/privacy-policy/"
        target="_blank"
        className="underline"
        key="barclays"
    >
        Barclays Bank Plc
    </a>,
    <a
        href="https://beverleybs.co.uk/privacy-notice"
        target="_blank"
        className="underline"
        key="beverley"
    >
        Beverley Building Society
    </a>,
    <a
        href="https://bluestone.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="bluestone"
    >
        Bluestone Mortgages Ltd
    </a>,
    <a
        href="https://www.bucksbs.co.uk/privacy.html"
        target="_blank"
        className="underline"
        key="bucks"
    >
        Buckinghamshire Building Society
    </a>,
    <a
        href="https://ccbank.co.uk/about-us/our-commitments/privacy-notice/"
        target="_blank"
        className="underline"
        key="ccbank"
    >
        Cambridge &amp; Counties Bank
    </a>,
    <a
        href="https://www.castletrust.co.uk/home/important-information#privacy-policy"
        target="_blank"
        className="underline"
        key="castle-trust"
    >
        Castle Trust Capital plc T/A Castle Trust
    </a>,
    <a
        href="https://www.centraltrust.co.uk/legal-and-privacy-policy"
        target="_blank"
        className="underline"
        key="central-trust"
    >
        Central Trust Ltd
    </a>,
    <a
        href="https://www.chorleybs.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="chorley"
    >
        Chorley Building Society
    </a>,
    <a
        href="https://secure.cbonline.co.uk/site-information/legal-privacy/"
        target="_blank"
        className="underline"
        key="clydesdale"
    >
        Clydesdale Bank
    </a>,
    <a
        href="https://www.coventrybuildingsociety.co.uk/content/cbs/consumer/en/help/privacy-policy.html"
        target="_blank"
        className="underline"
        key="coventry"
    >
        Coventry Building Society
    </a>,
    <a
        href="https://www.coutts.com/privacy-and-cookie-policy.html"
        target="_blank"
        className="underline"
        key="coutts"
    >
        Coutts &amp; Company
    </a>,
    <a
        href="https://www.esbs.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="esbs"
    >
        Earl Shilton Building Society (ESBS)
    </a>,
    <a
        href="https://www.equifinance.co.uk/privacy-notice"
        target="_blank"
        className="underline"
        key="equifinance"
    >
        Equifinance Ltd
    </a>,
    <a
        href="https://www.evolutionmoney.co.uk/legal/fair-processing-notice"
        target="_blank"
        className="underline"
        key="evolution-money"
    >
        Evolution Money Ltd
    </a>,
    <a
        href="https://www.finsec.co.uk/use-of-personal-information/"
        target="_blank"
        className="underline"
        key="finsec"
    >
        FinSec
    </a>,
    <a
        href="https://finioloans.com/privacy-policy"
        target="_blank"
        className="underline"
        key="finio"
    >
        Finio Loans
    </a>,
    <a
        href="https://www.ncbs.co.uk/about-us/privacy-and-cookies"
        target="_blank"
        className="underline"
        key="ncbs"
    >
        National Counties Building Society T/A Family Building Society
    </a>,
    <a
        href="https://www.fleetmortgages.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="fleet-mortgage"
    >
        Fleet Mortgages Ltd
    </a>,
    <a
        href="https://www.furnessbs.co.uk/legal/"
        target="_blank"
        className="underline"
        key="furness"
    >
        Furness Building Society
    </a>,
    <a
        href="https://www.foundationforintermediaries.co.uk/legal-statement/"
        target="_blank"
        className="underline"
        key="foundation-home-loans"
    >
        Foundation Home Loans
    </a>,
    <a
        href="https://www.funding-365.com/_files/ugd/66e79f_cc005c184bf649d3a31be19f8bb7ec21.pdf"
        target="_blank"
        className="underline"
        key="funding-365"
    >
        Funding 365
    </a>,
    <a
        href="https://gatehousebank.com/privacy-policy"
        target="_blank"
        className="underline"
        key="gatehouse"
    >
        Gatehouse Bank
    </a>,
    <a
        href="https://www.guarantormyloan.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="guarantor-my-loan"
    >
        Guarantor My Loan
    </a>,
    <a
        href="http://goldentreefs.co.uk/docs/privacy-policy.pdf"
        target="_blank"
        className="underline"
        key="goldentree"
    >
        Goldentree
    </a>,
    <a
        href="https://www.htb.co.uk/Portals/0/downloads/corporate/HTB-fair-processing-notice-for-customers-and-suppliers-06.04.2018.pdf"
        target="_blank"
        className="underline"
        key="htb"
    >
        Hampshire Trust Bank
    </a>,
    <a
        href="https://thehanley.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="hanley"
    >
        Hanley Economic Building Society
    </a>,
    <a
        href="https://www.halifax-intermediaries.co.uk/pdf/data_privacy_notice.pdf"
        target="_blank"
        className="underline"
        key="halifax"
    >
        Halifax Plc
    </a>,
    <a
        href="https://www.harpendenbs.co.uk/about-us/your-privacy/privacy-notice/"
        target="_blank"
        className="underline"
        key="harpenden"
    >
        Harpenden Building Society
    </a>,
    <a href="https://www.hrbs.co.uk/privacy/" target="_blank" className="underline" key="hrbs">
        Hinckley &amp; Rugby Building Society
    </a>,
    <a
        href="https://www.hsbc.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="hsbc"
    >
        HSBC Bank plc
    </a>,
    <a href="https://hodgebank.co.uk/privacy/" target="_blank" className="underline" key="hodge">
        Hodge Lifetime
    </a>,
    <a
        href="https://hope-capital.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="hope"
    >
        Hope Capital
    </a>,
    <a
        href="https://www.interbay.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="interbay"
    >
        Interbay Funding
    </a>,
    <a
        href="https://www.investec.com/en_gb/legal/privacy-policy.html"
        target="_blank"
        className="underline"
        key="investec"
    >
        Investec Specialist Bank
    </a>,
    <a
        href="https://www.kensingtonmortgages.co.uk/compliance/terms-of-use"
        target="_blank"
        className="underline"
        key="kensington"
    >
        Kensington Mortgages
    </a>,
    <a
        href="https://www.kentreliance.co.uk/legal/privacy-policy"
        target="_blank"
        className="underline"
        key="kent"
    >
        Kent Reliance
    </a>,
    <a
        href="http://www.keystonepropertyfinance.co.uk/privacy-cookie-policies/"
        target="_blank"
        className="underline"
        key="keystone"
    >
        Keystone Property Finance
    </a>,
    <a
        href="https://landbay.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="landbay"
    >
        Landbay
    </a>,
    <a
        href="https://www.leedsbuildingsociety.co.uk/security/use-of-personal-information/"
        target="_blank"
        className="underline"
        key="leeds"
    >
        Leeds Building Society
    </a>,
    <a
        href="https://www.leekunited.co.uk/full-privacy-notice/"
        target="_blank"
        className="underline"
        key="leek"
    >
        Leek Building Society
    </a>,
    <a
        href="https://www.lendingworks.co.uk/privacy"
        target="_blank"
        className="underline"
        key="lending-works"
    >
        Lending Works
    </a>,
    <a
        href="https://www.lendinvest.com/terms-and-conditions/privacy-policy/"
        target="_blank"
        className="underline"
        key="lendinvest"
    >
        Lendinvest Ltd
    </a>,
    <a
        href="https://www.bmsolutions.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="bms"
    >
        Bank of Scotland plc T/A BM Solutions
    </a>,
    <a
        href="https://www.mansfieldbs.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="mansfield"
    >
        Mansfield Building Society
    </a>,
    <a href="https://www.mfsuk.com/privacy-gdpr/" target="_blank" className="underline" key="mfs">
        Market Financial Solutions
    </a>,
    <a href="https://mhbs.co.uk/privacy-policy/" target="_blank" className="underline" key="mhbs">
        Market Harborough Building Society
    </a>,
    <a
        href="https://www.metrobankonline.co.uk/about-us/privacy-and-security/#Cookies%20Policy"
        target="_blank"
        className="underline"
        key="metro"
    >
        Metro Bank
    </a>,
    <a
        href="https://www.mercantiletrust.co.uk/legal-and-privacy-policy/"
        target="_blank"
        className="underline"
        key="mercantile"
    >
        Mercantile Trust Ltd
    </a>,
    <a
        href="https://www.mrlender.com/privacy-notice"
        target="_blank"
        className="underline"
        key="mr-lender"
    >
        Mr Lender
    </a>,
    <a
        href="https://mycommunitybank.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="my-community"
    >
        My Community Bank
    </a>,
    <a href="https://www.monbs.com/privacy/" target="_blank" className="underline" key="monbs">
        Monmouth Building Society
    </a>,
    <a
        href="https://www.mt-finance.com/privacy-policy/"
        target="_blank"
        className="underline"
        key="mt-finance"
    >
        MT Finance Limited
    </a>,
    <a
        href="https://www.nationwide-intermediary.co.uk/terms-and-conditions"
        target="_blank"
        className="underline"
        key="nationwide"
    >
        Nationwide Building Society
    </a>,
    <a
        href="http://www.intermediary.natwest.com/intermediary-solutions/hygiene/privacy.html"
        target="_blank"
        className="underline"
        key="natwest"
    >
        NatWest Bank
    </a>,
    <a
        href="https://www.newbury.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="newbury"
    >
        Newbury Building Society
    </a>,
    <a
        href="https://www.newcastle.co.uk/faqs/website-online-services/privacy-data-protection-policy/"
        target="_blank"
        className="underline"
        key="newcastle"
    >
        Newcastle Building Society
    </a>,
    <a
        href="https://www.thenottingham.com/~/media/files/generic/our-privacy-policy.pdf"
        target="_blank"
        className="underline"
        key="nottingham"
    >
        Nottingham Building Society
    </a>,
    <a
        href="https://www.oaknorth.co.uk/privacy-notice/?noredirect"
        target="_blank"
        className="underline"
        key="oaknorth"
    >
        Oaknorth Bank plc
    </a>,
    <a
        href="https://octopus-realestate.com/privacy-notice/"
        target="_blank"
        className="underline"
        key="octopus"
    >
        Octopus Real Estate
    </a>,
    <a
        href="https://www.paragonbank.co.uk/data-protection"
        target="_blank"
        className="underline"
        key="paragon"
    >
        Paragon Bank PLC
    </a>,
    <a
        href="https://www.pepper-advantage.com/pepper-advantage-privacy-policy"
        target="_blank"
        className="underline"
        key="pepper"
    >
        Pepper (UK) Ltd
    </a>,
    <a
        href="https://www.pepper.money/about-us/policies/privacy-policy/"
        target="_blank"
        className="underline"
        key="pepper-money"
    >
        Pepper Money
    </a>,
    <a
        href="https://www.pivotfinance.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="pivot"
    >
        Pivot Finance
    </a>,
    <a
        href="https://www.plata.com/s/privacy-policy"
        target="_blank"
        className="underline"
        key="plata"
    >
        Plata Finance Limited
    </a>,
    <a
        href="https://www.platform.co.uk/privacy-and-cookies/privacy-policy/index"
        target="_blank"
        className="underline"
        key="platform"
    >
        Platform
    </a>,
    <a
        href="https://pluto-finance.com/privacy-policy/"
        target="_blank"
        className="underline"
        key="pluto"
    >
        Pluto Capital – Bridging
    </a>,
    <a
        href="https://www.precisemortgages.co.uk/PrivacyNotice"
        target="_blank"
        className="underline"
        key="precise"
    >
        Precise Mortgages
    </a>,
    <a
        href="https://www.principality.co.uk/en/privacy-and-security"
        target="_blank"
        className="underline"
        key="principality"
    >
        Principality Building Society
    </a>,
    <a
        href="https://theprogressive.com/privacy-policy"
        target="_blank"
        className="underline"
        key="progressive"
    >
        Progressive Building Society
    </a>,
    <a
        href="https://www.propfin.com/privacy-policy/"
        target="_blank"
        className="underline"
        key="propfin"
    >
        PropFin
    </a>,
    <a
        href="https://quantummortgages.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="quantum"
    >
        Quantum Mortgages
    </a>,
    <a
        href="https://romafinance.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="roma"
    >
        Roma Finance
    </a>,
    <a
        href="https://www.saffronbs.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="saffron"
    >
        Saffron Building Society
    </a>,
    <a
        href="https://www.santander.co.uk/personal/support/customer-support/legal-information"
        target="_blank"
        className="underline"
        key="santander"
    >
        Santander
    </a>,
    <a
        href="https://www.scottishwidows.co.uk/legal-information/"
        target="_blank"
        className="underline"
        key="scottish"
    >
        Scottish Widows
    </a>,
    <a
        href="https://www.selinaadvance.com/privacy-policy"
        target="_blank"
        className="underline"
        key="selina"
    >
        Selina Finance Ltd
    </a>,
    <a
        href="https://www.shawbrook.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="shawbrook"
    >
        Shawbrook Bank
    </a>,
    <a
        href="https://www.skipton.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="skipton"
    >
        Skipton Building Society
    </a>,
    <a
        href="https://springfinance.co.uk/customer-privacy-policy/"
        target="_blank"
        className="underline"
        key="spring"
    >
        Spring Finance
    </a>,
    <a
        href="https://srbs.co.uk/srbs-your-privacy-matters-to-us"
        target="_blank"
        className="underline"
        key="srbs"
    >
        Stafford Railway Building Society
    </a>,
    <a
        href="https://www.steponefinance.co.uk/legal-notices/"
        target="_blank"
        className="underline"
        key="stepone"
    >
        Step One
    </a>,
    <a
        href="https://www.suffolkbuildingsociety.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="suffolk"
    >
        Suffolk Building Society
    </a>,
    <a
        href="https://www.swansea-bs.co.uk/privacy-information"
        target="_blank"
        className="underline"
        key="swansea"
    >
        Swansea Building Society
    </a>,
    <a
        href="https://www.tandem.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="tandem"
    >
        Tandem Home Loans Limited
    </a>,
    <a
        href="https://www.teachersbuildingsociety.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="teachers"
    >
        Teachers Building Society
    </a>,
    <a
        href="https://www.cambridgebs.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="cambridge"
    >
        The Cambridge Building Society
    </a>,
    <a
        href="https://www.theloughborough.co.uk/privacy-and-cookies"
        target="_blank"
        className="underline"
        key="loughborough"
    >
        The Loughborough Building Society
    </a>,
    <a
        href="https://www.themelton.co.uk/how-we-use-your-information/"
        target="_blank"
        className="underline"
        key="melton"
    >
        The Melton Building Society
    </a>,
    <a
        href="https://themortgagelender.com/privacy-and-fair-processing-notice"
        target="_blank"
        className="underline"
        key="mortgage-lender"
    >
        The Mortgage Lender
    </a>,
    <a
        href="https://www.themortgageworks.co.uk/terms-and-conditions"
        target="_blank"
        className="underline"
        key="mortgage-works"
    >
        The Mortgage Works
    </a>,
    <a
        href="https://www.thetipton.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="tipton"
    >
        Tipton &amp; Coseley Building Society
    </a>,
    <a
        href="https://togethermoney.com/privacy-and-cookie-policy/"
        target="_blank"
        className="underline"
        key="together"
    >
        Together Commercial Ltd
    </a>,
    <a
        href="https://togethermoney.com/privacy-and-cookie-policy/"
        target="_blank"
        className="underline"
        key="together-personal"
    >
        Together Personal Finance Ltd
    </a>,
    <a href="https://www.tsb.co.uk/privacy/" target="_blank" className="underline" key="tsb">
        TSB Bank Plc
    </a>,
    <a
        href="https://ultimatefinance.co.uk/privacy-policy"
        target="_blank"
        className="underline"
        key="ultimate-finance"
    >
        Ultimate Finance
    </a>,
    <a
        href="https://www.utbank.co.uk/privacy-notice/"
        target="_blank"
        className="underline"
        key="utbank"
    >
        United Trust Bank
    </a>,
    <a
        href="https://www.thevernon.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="vernon"
    >
        Vernon Building Society
    </a>,
    <a
        href="https://www.vidahomeloans.co.uk/intermediaries/the-legal-stuff"
        target="_blank"
        className="underline"
        key="vida"
    >
        Vida Homeloans
    </a>,
    <a
        href="https://uk.virginmoney.com/security/"
        target="_blank"
        className="underline"
        key="virgin"
    >
        Virgin Money plc
    </a>,
    <a
        href="https://www.westoneloans.co.uk/privacy-policy/"
        target="_blank"
        className="underline"
        key="westone"
    >
        West One Loans Ltd
    </a>,
    <a
        href="https://zephyrhomeloans.co.uk/privacy/"
        target="_blank"
        className="underline"
        key="zephyr"
    >
        Zephyr Home Loans
    </a>,
];

const LenderLinks = () => {
    const [expanded, setExpanded] = useState(false);
    const dataForDisplay = expanded ? links : links.slice(0, 10);

    return (
        <ul className="space-y-1" style={{ paddingLeft: 25 }}>
            {dataForDisplay.map((link, index) => (
                <li key={`lender-link-${index}`}>{link}</li>
            ))}
            <button
                type="button"
                onClick={() => setExpanded(!expanded)}
                className="flex justify-end w-full underline text-darkblue decoration-darkblue"
            >
                {expanded ? 'Show Less' : 'Show More'}
            </button>
        </ul>
    );
};

export default LenderLinks;
